export const createSlug = (title) => title.toLowerCase().replace(/\s/, "-");
